/**
 * Constants related to property key modification warnings
 */

/**
 * Warning message for modifying base content keys
 */
export const BASE_KEY_MODIFICATION_WARNING =
    'Modifying this key may affect reports, automation, and integrations.' as const

/**
 * Additional context message for base key modification warning
 */
export const BASE_KEY_MODIFICATION_CONTEXT =
    'Consistent spec data structure ensures accurate results and seamless information exchange.' as const

/**
 * Warning message for attempting to modify Product Type keys
 */
export const PT_KEY_MODIFICATION_WARNING =
    'Product Type keys cannot be modified. Copy the Product Type to create a customized version.' as const

/**
 * Session storage key for tracking dismissed key modification warnings per project
 */
export const KEY_MODIFICATION_WARNING_DISMISSED_KEY =
    'key-modification-warning-dismissed' as const
